export default "__VITE_ASSET__0d378ad0__"